import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-history",
  "use": "icon-history-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 64 64\" id=\"icon-history\">\r\n<path d=\"M37,31.6v-8.2c0-2.3-1.8-4.1-4.1-4.1c-2.3,0-4.1,1.8-4.1,4.1v12.3c0,2.3,1.8,4.1,4.1,4.1h12.3c2.3,0,4.1-1.8,4.1-4.1\r\n\tc0-2.3-1.8-4.1-4.1-4.1C45.2,31.6,37,31.6,37,31.6z M32.9,60.2c-15.8,0-28.6-12.8-28.6-28.6C4.3,15.8,17.1,3,32.9,3c0,0,0,0,0,0\r\n\tc15.8,0,28.6,12.8,28.6,28.6C61.5,47.4,48.7,60.2,32.9,60.2z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/history.svg
// module id = nTk5
// module chunks = 171